/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './returnItem.module.css';
import { SelectCheckmark } from '../SelectCheckmark';
import { currencyService } from '../../services/currency-service/currency-service';
import { ItemProperties } from './itemProperties';
import ItemImage from './ItemImage';
import { Language } from '../../react-components/Language';

const mapStateToProps = ({
  language,
  page: { productType, locale } = {},
  returnsSettings: {
    [productType]: {
      exchange: { unevenExchanges } = {},
      bundles: { enabled: bundlesEnabled } = {},
    } = {},
  } = {},
  orderService: { bundleItems = {} } = {},
}) => ({
  language,
  unevenExchanges,
  locale,
  bundleItems,
  bundlesEnabled,
});

const ReturnItem = ({
  className,
  item,
  itemQty,
  itemSubtotal,
  eligibleStatus,
  itemSidebar,
  type,
  blindItem,
  product,
  showCheckmark,
  overrideCheckmarkDisplay,
  overrideItemStatus,
  overrideItemWarning,
  itemIndex,
  language,
  disabled,
  unevenExchanges,
  locale,
  bundleItems,
  bundlesEnabled,
}) => {
  if (!item) return null;
  const isUnevenExchange = unevenExchanges && item?.exchange_item;
  const getStatusMsg = item.itemStatus
    ? {
        content: item.itemStatus,
      }
    : typeof overrideItemStatus === 'string'
      ? { content: overrideItemStatus }
      : overrideItemStatus;

  const isSelected = (item && item.selected) || overrideCheckmarkDisplay;
  const getWarning = () => item.itemWarning || overrideItemWarning;

  const bundleMessage =
    bundlesEnabled && bundleItems[item.item_id] ? bundleItems[item.item_id].message : undefined;

  const handleSelection = (e) => {
    if (e.type === 'click' || e.key === 'Enter') {
      itemSidebar({ item, disabled: disabled || Boolean(bundleMessage) });
    }
  };

  const containerClasses = [
    s.item_container,
    className,
    isSelected ? s.item_selected : '',
    isSelected ? 'selected-item' : '',
    type === 'summary' ? s.summary_item : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={containerClasses}
      onClick={() => {
        handleSelection({ type: 'click' });
      }}
      onKeyDown={handleSelection}
      role={item.return_eligibility ? 'button' : 'none'}
      tabIndex={!item.return_eligibility || type === 'summary' ? -1 : 0}
    >
      {/* Return Item Image */}
      <div className={s.item_image_container}>
        <ItemImage
          src={item?.product_image_url}
          item={item}
          blindItem={blindItem}
          exchange={
            isUnevenExchange
              ? {
                  old: item.product_image_url,
                  new: item.exchange_item?.item_image,
                }
              : undefined
          }
          className={`return-item-${itemIndex}-image`}
        />
      </div>

      {/* Return Item Information */}
      <div className={s.item_information_container}>
        <h4
          className={`${s.item_name} return-summary-item return-item-${itemIndex}-name`}
          dangerouslySetInnerHTML={{
            __html: isUnevenExchange ? item.exchange_item?.title : item.item_name,
          }}
        />

        <ItemProperties
          item={item}
          itemIndex={itemIndex}
          language={language}
          itemQty={itemQty}
          exchangeAttributes={isUnevenExchange ? item.exchange_item?.attributes : undefined}
          locale={locale}
        />

        {/* Item Status */}
        <div>
          {item.clearance_sale && (
            <p
              className={s.item_status}
              dangerouslySetInnerHTML={{ __html: language['returns.item.clearance_sale'] }}
            />
          )}
          {getStatusMsg && (
            <Language
              {...getStatusMsg}
              tagName="span"
              className={`return-item-status-text ${s.item_status}`}
            />
          )}
          {eligibleStatus && (
            <span
              className={`return-item-eligible-text ${s.item_status}`}
              dangerouslySetInnerHTML={{ __html: eligibleStatus }}
            />
          )}
          {getWarning() && (
            <span
              className={`${s.item_warning} error-text`}
              dangerouslySetInnerHTML={{ __html: getWarning() }}
            />
          )}
          {bundleMessage && (
            <Language
              className={`return-item-bundles-warning ${s.item_warning} error-text`}
              langKey={bundleMessage}
            />
          )}
        </div>

        {/* Item Subtotal */}
        <div className={`item-price-display ${s.item_subtotal_container}`}>
          <p className={s.item_subtotal}>
            {blindItem && product === 'returns'
              ? language['returns.general.to_be_determined']
              : (itemSubtotal !== null &&
                  typeof itemSubtotal !== 'undefined' &&
                  currencyService.formatPrice(itemSubtotal)) ||
                itemSubtotal ||
                language['returns.general.display_price']}
          </p>
        </div>

        {/* Itemized Details Container */}
        {item.itemized_details && (
          <div className={s.itemized_details_container}>
            <strong
              dangerouslySetInnerHTML={{ __html: language['returns.item.return_quantity_label'] }}
            />
            {item.itemized_details.map((detail, index) => (
              <div key={index}>
                {`${language['returns.item.qty_label']}${detail.quantity} | ${language['returns.item.expiry_date_label']}${detail.expiry_date}`}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Checkmark Display */}
      {showCheckmark && (
        <div>
          <SelectCheckmark selected={isSelected} />
        </div>
      )}

      <div className="clearfix" />
    </div>
  );
};

export const ItemCard = connect(mapStateToProps)(ReturnItem);

ReturnItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string,
    item_name: PropTypes.string.isRequired,
    product_image_url: PropTypes.string,
    item_properties: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        displayable: PropTypes.bool,
      }),
    ),
    item_price: PropTypes.number,
    itemQty: PropTypes.string,
    item_category: PropTypes.string,
    clearance_sale: PropTypes.bool,
    item_status: PropTypes.string,
    itemized_details: PropTypes.arrayOf(
      PropTypes.shape({
        quantity: PropTypes.number.isRequired,
        expiry_date: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
  itemQty: PropTypes.string,
  itemSubtotal: PropTypes.number,
  eligibleStatus: PropTypes.string,
  itemSidebar: PropTypes.func,
  type: PropTypes.string,
  blindItem: PropTypes.bool,
  product: PropTypes.string,
  showCheckmark: PropTypes.bool,
  overrideCheckmarkDisplay: PropTypes.bool,
  overrideItemStatus: PropTypes.string,
  overrideItemWarning: PropTypes.string,
  itemIndex: PropTypes.number.isRequired,
  language: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  unevenExchanges: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  bundleItems: PropTypes.object.isRequired,
};

ReturnItem.defaultProps = {
  className: '',
  itemQty: 'qty',
  itemSubtotal: null,
  eligibleStatus: '',
  type: '',
  blindItem: false,
  product: '',
  showCheckmark: false,
  overrideCheckmarkDisplay: false,
  overrideItemStatus: '',
  overrideItemWarning: '',
  itemSidebar: () => {},
  disabled: undefined,
  unevenExchanges: undefined,
};
